/* tslint:disable:max-line-length */
import { DefaultMessages, RequestOrganizationMessages } from '@sheerid/jslib';

type RecursivePartial<T> = {
    [P in keyof T]?: RecursivePartial<T[P]>;
};

type ThisProjectMessages = {
    locales: {
        en: string, // need to support `en` in additon to `en-US` for ADSK's requirements
        is: string, // need to support `is` for ADSK's requirements
        ro: string, // need to support `ro` for ADSK's requirements
    },
    countries: {
        CD: string, // the jslib doesn't include a country code for Democratic Republic of Congo
        CZ: string, // the jslib uses the incorrect country code for Czech Republic
        PS: string, // the jslib doesn't include a country code for Palestine
        SS: string, // the jslib doesn't include a country code for South Sudan
        TL: string, // the jslib doesn't include a country code for Timor-Leste
    },
};


type LibraryMessages = DefaultMessages & RequestOrganizationMessages;

export const trRequestOrgMessages: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    title: 'Okul Ekleme Talebi',
    description: 'Lütfen aşağıdaki formu doldurunuz. Önerilen okulların ekleneceği garanti edilmez, ancak tüm talepler araştırılmış ve SheerID tarafından değerlendirilmiştir. ',
    noCountry: 'Okulunuzun bulunduğu ülkeyi göremiyor musun? Bu teklif için uygun değilsiniz',
    searchByOrgName: 'Okulunuzu göremiyor musun? İsme göre arayın',
    completeRequest: 'Okulunuzu uygun veya uygun olmayan okullar listesinde göremiyor musunuz? Talebinizi tamamlayın',
    submit: 'Gönder',
    eligibleOrgs: 'Uygun okullar. Adı kopyalamak için simgeye tıklayın, ardından doğrulama formuna dönün',
    ineligibleOrgs: 'Uygun Olmayan Okullar. Maalesef, bu okullardaki öğrenciler bu teklif için uygun değil',
    none: 'Hiçbiri',
    country: 'Nerede okula gidiyorsunuz?',
    changeLanguage: 'Dili değiştir',
    copied: 'Kopyalanan',
    firstName: 'İsim',
    lastName: 'Soyadı',
    emailAddress: 'E-posta',
    poweredBy: 'Doğrulama hizmeti SheerID tarafından sağlanmaktadır',
    fields: {
        countryPlaceholder: 'Ülke Seç',
        domainLabel: 'Okulun web sitesi',
        domainPlaceholder: 'www.benimokulum.tr',
        orgNameLabel: 'Okul İsmi',
        orgNamePlaceholder: 'Benim okulum',
    },
    step: {
        success: {
            title: 'Teşekkür ederiz',
            description: 'Eğitim kurumu ekleme talebiniz alındı. Lütfen talebinizle ilgili araştırmanın sonuçlanmasının 7 günü bulabileceğini ve söz konusu kurumun Autodesk ürünlerine eğitim amacıyla erişmeye uygun olan nitelikli eğitim kurumları listesine ekleneceğine dair herhangi bir garanti verilmediğini unutmayın.<br><br>Bu arada alternatif abonelik seçeneklerini araştırmayı da düşünebilirsiniz.',
        },
        error: {
            title: 'Beklenmedik bir sorun oluştu',
            description: 'Üzgünüz talebinizi işleme koyamıyoruz. Lütfen daha sonra tekrar deneyiniz.',
            seeingProblem: 'Bu sorunla karşılaşmaya devam ederseniz',
            contactUs: 'bizimle iletişime geçin',
        },
    },
    errorId: {
        invalidCountry: 'Bu alan gereklidir',
        invalidEmail: 'Geçeriz E-posta',
        invalidFirstName: 'Geçersiz isim',
        invalidLastName: 'Geçersiz soyadı',
        requiredField: 'Bu alan gereklidir',
        invalidField: 'Geçersiz alan',
        invalidUrl: 'Geçersiz URL',
        tooManyResults: 'Aramanız çok fazla sonuç verdi, lütfen aramanızı daraltın ve tekrar deneyin',
    },
    faq: 'SheerID Okul Ekleme İşlemi ile ilgili Sıkça Sorulan Sorular',
    countries: {
        AD: ' Andorra',
        AE: 'Birleşik Arap Emirlikleri',
        AF: 'Afganistan',
        AG: 'Antigua ve Barbuda',
        AI: 'Anguilla',
        AL: 'Arnavutluk',
        AM: 'Ermenistan',
        AN: 'Hollanda Antilleri',
        AO: 'Angola',
        AR: 'Arjantin',
        AS: 'Amerikan Samoası',
        AT: 'Avusturya',
        AU: 'Avustralya',
        AW: 'Aruba',
        AZ: 'Azerbeycan',
        BA: 'Bosna-Hersek',
        BB: 'Barbados',
        BD: 'Bangladeş',
        BE: 'Belçika',
        BF: 'Burkina Faso',
        BG: 'Bulgaristan',
        BH: 'Bahreyn',
        BI: 'Burundi',
        BJ: 'Benin',
        BM: 'Bermuda',
        BN: 'Brunei Sultanlığı',
        BO: 'Bolivya',
        BR: 'Brezilya',
        BS: 'Bahamalar',
        BT: 'Butan',
        BV: 'Bouvet Adası',
        BW: 'Botsvana',
        BY: 'Belarus',
        BZ: 'Belize',
        CA: 'Kanada',
        CD: 'Kongo Demokratik Cumhuriyeti',
        CF: 'Orta Afrika Cumhuriyeti',
        CG: 'Kongo',
        CH: 'İsviçre',
        CI: 'Fildişi Sahili',
        CK: 'Cook Adaları',
        CL: 'Şili',
        CM: 'Kamerun',
        CN: 'Çin',
        CO: 'Kolombiya',
        CR: 'Kosta Rika',
        CU: 'Küba',
        CV: 'Yeşil Burun Adaları',
        CY: 'Kıbrıs',
        CZ: 'Çek Cumhuriyeti',
        DE: 'Almanya',
        DJ: 'Cibuti',
        DK: 'Danimarka',
        DM: 'Dominika',
        DO: 'Dominik Cumhuriyeti',
        DZ: 'Cezayir',
        EC: 'Ekvador',
        EE: 'Estonya',
        EG: 'Mısır',
        EH: 'Batı Sahra',
        ER: 'Eritre',
        ES: 'İspanya',
        ET: 'Etiyopya',
        FI: 'Finlandiya',
        FJ: 'Fiji',
        FK: 'Falkland Adaları',
        FM: 'Mikronezya',
        FO: 'Faroe Adaları',
        FR: 'Fransa',
        GA: 'Gabon',
        GB: 'Birleşik Krallık',
        GD: 'Grenada',
        GE: 'Gürcistan',
        GF: 'Fransız Guyanası',
        GH: 'Gana',
        GI: 'Cebelitarık',
        GL: 'Grönland',
        GM: 'Gambiya',
        GN: 'Gine',
        GP: 'Guadeloupe (Fransızca)',
        GQ: 'Ekvator Ginesi',
        GR: 'Yunanistan',
        GS: 'Güney Georgia ve Güney Sandwich Adaları',
        GT: 'Guatemala',
        GU: 'Guam (ABD)',
        GW: 'Gine Bissau',
        GY: 'Guyana',
        HK: 'Hong Kong',
        HM: 'Heard ve McDonald Adaları',
        HN: 'Honduras',
        HR: 'Hırvatistan',
        HT: 'Haiti',
        HU: 'Macaristan',
        ID: 'Endonezya',
        IE: 'İrlanda',
        IL: 'İsrail',
        IN: 'Hindistan',
        IO: 'Britanya Hint Okyanusu Toprakları',
        IQ: 'Irak',
        IR: 'İran',
        IS: 'İzlanda',
        IT: 'İtalya',
        JM: 'Jamaika',
        JO: 'Ürdün',
        JP: 'Japonya',
        KE: 'Kenya',
        KG: 'Kırgızistan',
        KH: 'Kamboçya',
        KI: 'Kiribati',
        KM: 'Komorlar',
        KN: 'Saint Kitts ve Nevis Anguilla',
        KP: 'Kuzey Kore',
        KR: 'Güney Kore',
        KW: 'Kuveyt',
        KY: 'Cayman Adaları',
        KZ: 'Kazakistan',
        LA: 'Laos',
        LB: 'Lübnan',
        LC: 'Saint Lucia',
        LI: 'Lihtenştayn',
        LK: 'Sri Lanka',
        LR: 'Liberya',
        LS: 'Lesotho',
        LT: 'Litvanya',
        LU: 'Lüksemburg',
        LV: 'Letonya',
        LY: 'Libya',
        MA: 'Fas',
        MC: 'Monako',
        MD: 'Buğdan',
        ME: 'Karadağ',
        MG: 'Madagaskar',
        MH: 'Marşal Adaları',
        MK: 'Makedonya',
        ML: 'Mali',
        MM: 'Myanmar',
        MN: 'Moğolistan',
        MO: 'Makao',
        MP: 'Kuzey Mariana Adaları',
        MQ: 'Martinik (Fransızca)',
        MR: 'Moritanya',
        MS: 'Montserrat',
        MT: 'Malta',
        MU: 'Mauritius',
        MV: 'Maldivler',
        MW: 'Malawi',
        MX: 'Meksika',
        MY: 'Malezya',
        MZ: 'Mozambik',
        NA: 'Namibya',
        NC: 'Yeni Kaledonya (Fransızca)',
        NE: 'Nijer',
        NF: 'Norfolk Adası',
        NG: 'Nijerya',
        NI: 'Nikaragua',
        NL: 'Hollanda',
        NO: 'Norveç',
        NP: 'Nepal',
        NR: 'Nauru',
        NU: 'Niue',
        NZ: 'Yeni Zelanda',
        OM: 'Umman',
        PA: 'Panama',
        PE: 'Peru',
        PF: 'Polinezya (Fransızca)',
        PG: 'Papua Yeni Gine',
        PH: 'Filipinler',
        PK: 'Pakistan',
        PL: 'Polonya',
        PM: 'Saint Pierre ve Miquelon',
        PN: 'Pitcairn Adası',
        PR: 'Porto Riko',
        PS: 'Filistin',
        PT: 'Portekiz',
        PW: 'Palau',
        PY: 'Paraguay',
        QA: 'Katar',
        RE: 'Reunion (Fransızca)',
        RO: 'Romanya',
        RS: 'Sırbistan',
        RU: 'Rusya Federasyonu',
        RW: 'Ruanda',
        SA: 'Suudi Arabistan',
        SB: 'Solomon Adaları',
        SC: 'Seyşeller',
        SD: 'Sudan',
        SE: 'İsveç',
        SG: 'Singapur',
        SH: 'Saint Helena',
        SI: 'Slovenya',
        SK: 'Slovak cumhuriyeti',
        SL: 'Sierra Leone',
        SM: 'San Marino',
        SN: 'Senegal',
        SO: 'Somali',
        SR: 'Surinam',
        SS: 'Güney Sudan',
        ST: 'Saint Tome (Sao Tome) ve Principe',
        SV: 'El Salvador',
        SY: 'Suriye',
        SZ: 'Svaziland',
        TC: 'Turks ve Caicos Adaları',
        TD: 'Çad',
        TF: 'Fransız Güney Toprakları',
        TG: 'Gitmek',
        TH: 'Tayland',
        TJ: 'Tacikistan',
        TK: 'Tokelau',
        TL: 'Timor-Leste',
        TM: 'Türkmenistan',
        TN: 'Tunus',
        TO: 'Tonga',
        TR: 'Türkiye',
        TT: 'Trinidad ve Tobago',
        TV: 'Tuvalu',
        TW: 'Tayvan',
        TZ: 'Tanzanya',
        UA: 'Ukrayna',
        UG: 'Uganda',
        UM: 'ABD Küçük Dış Adaları',
        US: 'Amerika Birleşik Devletleri',
        UY: 'Uruguay',
        UZ: 'Özbekistan',
        VA: 'Vatikan Şehir Devleti',
        VC: 'Saint Vincent ve Grenadinler',
        VE: 'Venezuela',
        VG: 'Virgin Adaları (İngiliz)',
        VI: 'Virgin Adaları (ABD)',
        VN: 'Vietnam',
        VU: 'Vanuatu',
        WF: 'Wallis ve Futuna Adaları',
        WS: 'Samoa',
        XK: 'Kosova',
        YE: 'Yemen',
        YT: 'Mayotte',
        ZA: 'Güney Afrika',
        ZM: 'Zambiya',
        ZW: 'Zimbabve',
    },
    locales: {
        ar: 'Arapça',
        bg: 'Bulgar',
        cs: 'Çek',
        da: 'Danca',
        de: 'Almanca',
        el: 'Yunanca',
        'en-GB': 'İngilizce (UK)',
        'en-US': 'İngilizce',
        'es-ES': 'İspanyolca',
        es: 'İspanyolca',
        fi: 'Fince',
        'fr-CA': 'Fransız Kanadalı)',
        fr: 'Fransızca',
        hr: 'Hırvat',
        hu: 'Macarca',
        id: 'Endonezya',
        is: 'İzlandaca',
        it: 'İtalyanca',
        iw: 'İbranice',
        ja: 'Japonca',
        ko: 'Koreli',
        lt: 'Litvanyalı',
        ms: 'Malaya',
        nl: 'Flemenkçe',
        no: 'Norveççe',
        pl: 'Lehçe',
        'pt-BR': 'Portekizce',
        pt: 'Portekizce',
        ro: 'Romen',
        ru: 'Rusya',
        sk: 'Slovak',
        sl: 'Sloven',
        sr: 'Sırpça',
        sv: 'İsveççe',
        tr: 'Türkçe',
        'zh-HK': 'Çince (Hong Kong)',
        zh: 'Çin geleneği)',
    },
};
